import { Tooltip } from 'components/Tooltip/Tooltip'
import { FINANCIAL_STATUS_TYPES_TO_CLASSNAME, Status } from 'components/Status'
import { FINANCIAL_STATUS_LABEL } from '../constants'
import { getFinancialStatusTooltip } from './helpers'
import { FinancialStatusRow } from './types'

export const FinancialStatusCell = ({ row }: { row: FinancialStatusRow }) => (
  <Tooltip title={getFinancialStatusTooltip(row)}>
    <div>
      <Status.Default
        className={FINANCIAL_STATUS_TYPES_TO_CLASSNAME[row.status]}
      >
        {FINANCIAL_STATUS_LABEL[row.status]}
      </Status.Default>
    </div>
  </Tooltip>
)
